export const NextArrowBtn = ({ onClick }) => {
  return <span onClick={onClick} className="icofont-long-arrow-right"></span>;
};
